export interface EntryCard {
  id: string;
  category: string;
  title: string;
  desc: string;
  cover: string;
  stat: string;
}

export const entryCards: EntryCard[] = [
  {
    id: "hot-track",
    category: "实时跟踪",
    title: "热点追踪台",
    desc: "把正在发酵的话题实时聚合，标题点开即到，不用再一层层翻。",
    stat: "更新 · 每 15 分钟",
    cover:
      "https://readdy.ai/api/search-image?query=Warm%20editorial%20abstract%20composition%20of%20overlapping%20news%20cards%20and%20headline%20strips%20in%20coral%2C%20amber%20and%20cream%20tones%2C%20soft%20paper%20texture%2C%20generous%20negative%20space%2C%20minimal%20magazine%20layout%2C%20no%20text%2C%20stylized%20flat%20graphic%20design%2C%20artistic%20and%20calm&width=900&height=675&seq=entry-hot-01&orientation=landscape",
  },
  {
    id: "industry-insight",
    category: "深度栏目",
    title: "行业观察室",
    desc: "长文与背景梳理收录在一起，想深挖来龙去脉时,一站式把前因后果补齐。",
    stat: "存档 · 1200+ 篇",
    cover:
      "https://readdy.ai/api/search-image?query=Elegant%20editorial%20abstract%20art%20of%20stacked%20document%20sheets%20and%20magnifying%20glass%20silhouette%20in%20warm%20ink%20brown%2C%20terracotta%20and%20cream%20palette%2C%20fine%20line%20graphics%2C%20soft%20gradient%20background%2C%20minimal%20clean%20magazine%20style%2C%20no%20text%2C%20calm%20and%20premium%20feel&width=900&height=675&seq=entry-industry-02&orientation=landscape",
  },
  {
    id: "sports-stage",
    category: "现场速递",
    title: "文体现场集",
    desc: "比赛、现场、热梗一屏收齐，赛后第一时间去拿新鲜料，按条直达不迷路。",
    stat: "现场 · 实时",
    cover:
      "https://readdy.ai/api/search-image?query=Modern%20editorial%20abstract%20collage%20of%20confetti%20and%20dynamic%20curved%20ribbons%20in%20coral%20red%2C%20sand%20and%20cream%2C%20smooth%20paper%20canvas%2C%20stylish%20minimal%20graphic%20design%2C%20generous%20breathing%20space%2C%20no%20text%2C%20energetic%20yet%20elegant%20magazine%20feel&width=900&height=675&seq=entry-sports-03&orientation=landscape",
  },
  {
    id: "life-muse",
    category: "轻松闲逛",
    title: "生活妙趣角",
    desc: "好玩、好用、好读的轻内容清单，茶余饭后随手点,一条接一条不重样。",
    stat: "精选 · 每日上新",
    cover:
      "https://readdy.ai/api/search-image?query=Playful%20editorial%20abstract%20art%20of%20floating%20organic%20shapes%2C%20circles%20and%20leaves%20in%20warm%20amber%2C%20peach%20and%20ivory%20tones%2C%20soft%20clay%20texture%20background%2C%20minimal%20flat%20illustration%2C%20no%20text%2C%20light%20airy%20magazine%20composition&width=900&height=675&seq=entry-life-04&orientation=landscape",
  },
];

export interface TagGroup {
  label: string;
  tags: string[];
}

export const tagGroups: TagGroup[] = [
  {
    label: "正热",
    tags: ["本周热议", "深夜档", "话题榜首", "新鲜出炉", "回放中"],
  },
  {
    label: "想找",
    tags: ["一句话带火", "反转续集", "实锤整理", "时间线还原", "多方说法"],
  },
  {
    label: "慢慢看",
    tags: ["深度起底", "前因后果", "行业拆解", "人物故事", "番外整理"],
  },
  {
    label: "轻松点",
    tags: ["名场面", "高能瞬间", "冷知识", "下饭清单", "周末放空"],
  },
];

export interface IndexEntry {
  index: number;
  title: string;
  note: string;
  tag: string;
  time: string;
  read: string;
  href: string;
}

export interface CategoryGroup {
  key: string;
  name: string;
  intro: string;
  entries: IndexEntry[];
}

export const categories: CategoryGroup[] = [
  {
    key: "track",
    name: "热点追踪",
    intro: "正在升温的话题,按热度排序,点进即取,适合随时瞄一眼。",
    entries: [
      {
        index: 1,
        title: "科技圈这一周到底在吵什么",
        note: "把零散发言归成一条时间线,补课五分钟就够了。",
        tag: "跟踪",
        time: "今日 09:40",
        read: "热度 98",
        href: "#",
      },
      {
        index: 2,
        title: "一场发布会带火的三件事",
        note: "从官宣到网友考古,最新进展已整理到置顶。",
        tag: "跟踪",
        time: "今日 08:12",
        read: "热度 91",
        href: "#",
      },
      {
        index: 3,
        title: "热梗从哪来,又是怎么出圈的",
        note: "来源、扩散、二创三步都标注清楚,一看就懂。",
        tag: "追踪",
        time: "昨日 22:05",
        read: "热度 87",
        href: "#",
      },
      {
        index: 4,
        title: "深夜爆出的消息,天亮前都在这",
        note: "凌晨讨论不缺席,早上打开直接进入正题。",
        tag: "深夜档",
        time: "昨日 23:58",
        read: "热度 83",
        href: "#",
      },
    ],
  },
  {
    key: "context",
    name: "来龙去脉",
    intro: "怕跟不上前情?每条都附带背景卡片,先补设定再吃完整颗。",
    entries: [
      {
        index: 1,
        title: "事件时间线:从第一句开始还原",
        note: "谁先开口、怎么发酵,按节点逐条标注清楚。",
        tag: "时间线",
        time: "今日 10:20",
        read: "热度 94",
        href: "#",
      },
      {
        index: 2,
        title: "正反两方的说法,一次看全",
        note: "不同立场的原文与回应并列,自己判断最靠谱。",
        tag: "多方说法",
        time: "昨日 20:11",
        read: "热度 89",
        href: "#",
      },
      {
        index: 3,
        title: "旧账本:被重新翻出的往事",
        note: "历史发言与旧报道已逐条比对,避免只看单点。",
        tag: "考古",
        time: "昨日 16:47",
        read: "热度 78",
        href: "#",
      },
      {
        index: 4,
        title: "一份写给新人的前情提要",
        note: "三十秒扫清背景,零基础也能顺畅跟上全程。",
        tag: "补课",
        time: "周二 14:30",
        read: "热度 72",
        href: "#",
      },
    ],
  },
  {
    key: "stage",
    name: "文体现场",
    intro: "比赛与现场热梗收录,赛后第一时间刷新,按场次直达不迷路。",
    entries: [
      {
        index: 1,
        title: "总决赛落幕,全场名场面合集",
        note: "关键球、高光瞬间一次剪齐,回看按条直达。",
        tag: "名场面",
        time: "今日 07:55",
        read: "热度 96",
        href: "#",
      },
      {
        index: 2,
        title: "赛后感言速记:他们说了什么",
        note: "发布会原话整理,重点标记方便快速浏览。",
        tag: "现场",
        time: "今日 06:30",
        read: "热度 88",
        href: "#",
      },
      {
        index: 3,
        title: "演出现场的高能两分钟",
        note: "观众视角的高清片段已收录,直达无需切页。",
        tag: "高能瞬间",
        time: "昨日 23:12",
        read: "热度 84",
        href: "#",
      },
      {
        index: 4,
        title: "本周赛程与看点一页搞定",
        note: "对阵、时间、看点排期都在,按条点开即可。",
        tag: "排期",
        time: "周一 10:00",
        read: "热度 69",
        href: "#",
      },
    ],
  },
  {
    key: "light",
    name: "轻松闲逛",
    intro: "不用动脑的轻内容,随手点开一条,慢慢刷不累。",
    entries: [
      {
        index: 1,
        title: "一部下饭剧的下饭名场面",
        note: "弹幕与切片搭配,轻松又不占脑容量。",
        tag: "下饭清单",
        time: "今日 11:02",
        read: "热度 76",
        href: "#",
      },
      {
        index: 2,
        title: "冷知识:原来还能这样",
        note: "每期一小段,刷新认知刚刚好。",
        tag: "冷知识",
        time: "昨日 18:26",
        read: "热度 71",
        href: "#",
      },
      {
        index: 3,
        title: "周末放空:适合发呆看的合集",
        note: "慢节奏内容排成一列,别赶,慢慢逛。",
        tag: "周末放空",
        time: "上周日 15:00",
        read: "热度 65",
        href: "#",
      },
      {
        index: 4,
        title: "一句话好玩的轻梗盘点",
        note: "攒了几天的新梗,一次笑个够。",
        tag: "轻松",
        time: "上周六 21:30",
        read: "热度 68",
        href: "#",
      },
    ],
  },
];

export interface CoverPick {
  id: string;
  badge: string;
  title: string;
  meta: string;
  cover: string;
}

export const coverPicks: CoverPick[] = [
  {
    id: "pick-a",
    badge: "深度",
    title: "一张图看懂来龙去脉",
    meta: "背景卡片 · 收藏 4.2w",
    cover:
      "https://readdy.ai/api/search-image?query=Warm%20editorial%20abstract%20art%20of%20an%20open%20notebook%20with%20branching%20flow%20lines%20and%20highlight%20dots%20in%20terracotta%2C%20ink%20and%20cream%20tones%2C%20soft%20paper%20background%2C%20minimal%20flat%20design%2C%20no%20text%2C%20thoughtful%20calm%20magazine%20layout&width=720&height=900&seq=pick-deep-01&orientation=portrait",
  },
  {
    id: "pick-b",
    badge: "时间线",
    title: "把散落的线索串成一条线",
    meta: "还原梳理 · 收藏 3.8w",
    cover:
      "https://readdy.ai/api/search-image?query=Minimal%20editorial%20abstract%20collage%20of%20a%20winding%20timeline%20path%20with%20numbered%20pins%20in%20coral%2C%20sand%20and%20cream%20palette%2C%20clean%20clay%20texture%20background%2C%20stylish%20flat%20graphic%2C%20no%20text%2C%20organized%20elegant%20magazine%20feel&width=720&height=900&seq=pick-timeline-02&orientation=portrait",
  },
  {
    id: "pick-c",
    badge: "多方",
    title: "不同立场的一次读全",
    meta: "原文对照 · 收藏 3.1w",
    cover:
      "https://readdy.ai/api/search-image?query=Warm%20editorial%20abstract%20art%20of%20speech%20bubble%20shapes%20layered%20in%20amber%2C%20coral%20and%20cream%20tones%2C%20soft%20textured%20background%2C%20minimal%20flat%20design%2C%20no%20text%2C%20balanced%20calm%20magazine%20composition&width=720&height=900&seq=pick-voices-03&orientation=portrait",
  },
  {
    id: "pick-d",
    badge: "现场",
    title: "现场高光,一镜到底",
    meta: "实时回看 · 收藏 2.9w",
    cover:
      "https://readdy.ai/api/search-image?query=Energetic%20editorial%20abstract%20art%20of%20radiating%20rays%20and%20confetti%20dots%20in%20coral%20red%2C%20warm%20sand%20and%20ivory%2C%20soft%20paper%20canvas%2C%20minimal%20flat%20graphic%2C%20no%20text%2C%20vivid%20yet%20elegant%20magazine%20style&width=720&height=900&seq=pick-live-04&orientation=portrait",
  },
  {
    id: "pick-e",
    badge: "轻松",
    title: "放空时刻,慢慢刷不停",
    meta: "轻内容 · 收藏 2.5w",
    cover:
      "https://readdy.ai/api/search-image?query=Soft%20editorial%20abstract%20art%20of%20rounded%20cloud%20and%20leaf%20shapes%20drifting%20in%20peach%2C%20cream%20and%20sage%20tones%2C%20gentle%20clay%20texture%20background%2C%20minimal%20flat%20illustration%2C%20no%20text%2C%20relaxed%20airy%20magazine%20composition&width=720&height=900&seq=pick-chill-05&orientation=portrait",
  },
  {
    id: "pick-f",
    badge: "考古",
    title: "旧事重提,一次看个明白",
    meta: "回放整理 · 收藏 2.2w",
    cover:
      "https://readdy.ai/api/search-image?query=Retro%20editorial%20abstract%20art%20of%20overlapping%20archival%20tapes%20and%20stamps%20in%20warm%20brown%2C%20burnt%20orange%20and%20cream%2C%20aged%20paper%20texture%2C%20minimal%20flat%20design%2C%20no%20text%2C%20nostalgic%20calm%20magazine%20feel&width=720&height=900&seq=pick-archive-06&orientation=portrait",
  },
];

export interface Tip {
  no: string;
  title: string;
  desc: string;
}

export const tips: Tip[] = [
  {
    no: "01",
    title: "看榜单锁定目标",
    desc: "首屏就是当前最热的一批入口,扫一眼就知道今晚该看哪条。",
  },
  {
    no: "02",
    title: "点标签直达主题",
    desc: "想看哪类内容就点哪个标签墙,标题下面标注好了来源与时间。",
  },
  {
    no: "03",
    title: "收藏编号回头找",
    desc: "合集都有编号,顺手存下编号,下次回来按号就能直达,不用再搜。",
  },
];

export interface FaqItem {
  q: string;
  a: string;
}

export const faqItems: FaqItem[] = [
  {
    q: "这里的“入口”到底是什么?",
    a: "可以理解为一份被整理好的直达合集:每条都标注了所属主题与时效,点开后是跳转出去的原始页面,不做二次加工,方便你按需取用。",
  },
  {
    q: "为什么用短链方式?",
    a: "长串链接复制起来容易出错,这里的入口经过统一整理,复制更短、更好记,减少反复粘贴来回找的麻烦。",
  },
  {
    q: "合集会经常更新吗?",
    a: "会的。热度会变化,所以榜单、标签墙和封面精选会持续刷新,旧的、过时的会被归档,保证你打开的尽量是新鲜的。",
  },
  {
    q: "页面上的按钮点过去会怎样?",
    a: "这是落地展示页,入口以视觉方式排布供你了解版式。上线后,每条真实入口会替换为对应的直达跳转链接,收藏编号同样保留。",
  },
];

export const footerLinks: { group: string; items: string[] }[] = [
  { group: "快速导航", items: ["热点追踪", "来龙去脉", "文体现场", "轻松闲逛"] },
  { group: "使用帮助", items: ["找瓜三步", "短链说明", "收藏编号", "更新节奏"] },
  { group: "关于站点", items: ["站点介绍", "收录原则", "反馈建议", "隐私说明"] },
];